import { Checkbox, FormControl, FormControlLabel, FormControlLabelProps, FormGroup, InputLabel } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { useEffect, useState } from "react";

export const EcoCheckbox = (props: FieldProps<Array<CheckboxOption['value']>>) => {

    const [value, setValue] = useState<Array<CheckboxOption['value']>>(props.formData || [])
    const { options, inline } = (props.uiSchema['ui:options'] || {}) as CheckboxType

    useEffect(() => {
        props.onChange(value)
    }, [value])

    const handleChange = (val: CheckboxOption['value']) => {
        setValue((v) => {
            const _value = [...v]
            const index = _value.findIndex((item) => item === val)
            if (index !== -1) {
                _value.splice(index, 1)
            } else {
                _value.push(val)
            }

            return _value
        })
    }

    return (
        <FormControl>
            {
                props.title && <InputLabel>{props.title}</InputLabel>
            }
            <FormGroup row={inline}>
                {
                    options.map((item, index) => (
                        <FormControlLabel
                            key={index}
                            {...item}
                            control={
                                <Checkbox 
                                    id="liquidStateFormControl" 
                                    checked={value.includes(item.value)} />
                            }
                            onChange={() => handleChange(item.value)}
                            label={item.label}
                            className="ecoCheckbox"
                            />
                    ))
                }
            </FormGroup>
        </FormControl>
        
    )
}

type CheckboxType = {
    options: Array<CheckboxOption>
    inline?: boolean
}

type CheckboxOption = FormControlLabelProps & {
    value: unknown
}

export type PhysicalStateValue = 'LIQUID' | 'SOLID' | 'GAZ'
